import React,{useState} from 'react'

const MyAccordion =({children})=>{
    return (
        <>
            <ul className="list-group">
                {children}

            </ul>
        </>
    )
}
const MyAccordionItem = ({title,children}) => {
    const [isActive,setIsActive] =useState(false)

    return ( 
        <>
            <li className="list-group-item list-group-item-action d-flex justify-content-between align-items-center" onClick={() => setIsActive(!isActive)}>
               <div>{title}</div>
                <div>{isActive? <i className='bi bi-chevron-up'> </i>: <i className='bi bi-chevron-down'></i> }</div>
                
            </li>
            {isActive && <div className="card"><div className="card-body">{children}</div></div>}
        </>
     );
}
 
MyAccordion.Item = MyAccordionItem
export default MyAccordion;